import { useEffect, useState } from 'react';

// Fetch the effective lifetime purchase limit for the logged-in user on a
// single product. Returns { product_limit, category_limits, most_restrictive }
// or null when not logged in / not configured.

const tokenHdr = () => {
  const t = localStorage.getItem('token') || localStorage.getItem('authToken');
  return t ? { Authorization: `Bearer ${t}` } : null;
};

export default function usePurchaseLimit(productId) {
  const [data, setData] = useState(null);

  useEffect(() => {
    const h = tokenHdr();
    if (!h || !productId) return;
    let alive = true;
    fetch(`/api/purchase-limits/effective?product_id=${productId}`, { headers: h })
      .then(r => r.ok ? r.json() : null)
      .then(j => { if (alive) setData(j || null); })
      .catch(() => {});
    return () => { alive = false; };
  }, [productId]);

  return data;
}
